export default {
  en: Object.assign(
    {},
    require("@/i18n/en/comuns.json"),
    require("@/i18n/en/user.json"),
    require("@/i18n/en/form.json"),
    require("@/i18n/en/utils.json"),
    require("@/i18n/en/sharedComponents.json"),
    require("@/i18n/en/document.json"),
    require("@/i18n/en/profile.json"),
    require("@/i18n/en/messages.json"),
    require("@/i18n/en/menu.json"),
    require("@/i18n/en/course.json"),
    require("@/modules/library/i18n/en/index.json"),
    require("@/i18n/en/documentGroup.json"),
    require("@/i18n/en/configurations.json"),
    require("@/i18n/en/security.json"),
    require("@/i18n/en/department.json"),
    require("@/i18n/en/manuals.json"),
    require("@/i18n/en/companyLoging.json"),
    require("@/i18n/en/folders.json"),
    require("@/i18n/en/presetMessages.json"),
    require("@/i18n/en/request.json"),
  ),
  esp: Object.assign(
    {},
    require("@/i18n/esp/comuns.json"),
    require("@/i18n/esp/user.json"),
    require("@/i18n/esp/form.json"),
    require("@/i18n/esp/utils.json"),
    require("@/i18n/esp/sharedComponents.json"),
    require("@/i18n/esp/document.json"),
    require("@/i18n/esp/profile.json"),
    require("@/i18n/esp/messages.json"),
    require("@/i18n/esp/menu.json"),
    require("@/i18n/esp/course.json"),
    require("@/modules/library/i18n/esp/index.json"),
    require("@/i18n/esp/documentGroup.json"),
    require("@/i18n/esp/configurations.json"),
    require("@/i18n/esp/security.json"),
    require("@/i18n/esp/department.json"),
    require("@/i18n/esp/manuals.json"),
    require("@/i18n/esp/companyLoging.json"),
    require("@/i18n/esp/folders.json"),
    require("@/i18n/esp/presetMessages.json"),
    require("@/i18n/esp/request.json"),
  ),
  "pt-BR": Object.assign(
    {},
    require("@/i18n/pt-BR/comuns.json"),
    require("@/i18n/pt-BR/user.json"),
    require("@/i18n/pt-BR/form.json"),
    require("@/i18n/pt-BR/utils.json"),
    require("@/i18n/pt-BR/sharedComponents.json"),
    require("@/i18n/pt-BR/document.json"),
    require("@/i18n/pt-BR/profile.json"),
    require("@/i18n/pt-BR/messages.json"),
    require("@/i18n/pt-BR/menu.json"),
    require("@/i18n/pt-BR/course.json"),
    require("@/modules/library/i18n/pt-BR/index.json"),
    require("@/i18n/pt-BR/documentGroup.json"),
    require("@/i18n/pt-BR/configurations.json"),
    require("@/i18n/pt-BR/security.json"),
    require("@/i18n/pt-BR/department.json"),
    require("@/i18n/pt-BR/manuals.json"),
    require("@/i18n/pt-BR/companyLoging.json"),
    require("@/i18n/pt-BR/folders.json"),
    require("@/i18n/pt-BR/presetMessages.json"),
    require("@/i18n/pt-BR/request.json"),
  ),
};
